// Renders a value that has not yet been supplied by the business owner with a visible marker.
export const Placeholder = ({ field, className = "" }) => {
  if (!field.placeholder) return <span className={className}>{field.value}</span>;
  return (
    <span
      data-testid="placeholder-value"
      data-placeholder="true"
      title="This information has not been supplied yet and must be replaced before launch."
      className={`inline-block rounded border border-dashed border-red-400 bg-red-50 px-1.5 py-0.5 font-mono text-[0.85em] text-red-700 ${className}`}
    >
      {field.value}
    </span>
  );
};
